<script setup lang="ts">
const props = defineProps<{
	data: { translation_key_label?: string; label?: string; to: string; link?: boolean; newTab?: boolean; showOnlyOnPL?: boolean }[]
}>()

const i18nService = usei18nService()
const localePath = useLocalePath()
const { locale } = useI18n()
</script>

<template>
	<ul class="footer-links">
		<li v-for="(item, idx) in props.data" :key="idx">
			<NuxtLink v-if="item?.link" class="footer-links__item" :to="localePath(item.to)" target="_blank" :prefetch="false" rel="nofollow">{{
				i18nService.$tDynamic('components.footer.links_and_app.links', item.translation_key_label || item.label)
			}}</NuxtLink>
			<NuxtLink
				v-else-if="item?.showOnlyOnPL ? locale === 'pl' : true"
				class="footer-links__item"
				:prefetch="false"
				:to="localePath(item.to)"
				>{{ i18nService.$tDynamic('components.footer.links_and_app.links', item.translation_key_label || item.label) }}</NuxtLink
			>
		</li>
	</ul>
</template>

<style scoped lang="scss">
@import './Links';
</style>
